import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";
import Select from "react-select";

const qualificationOptions = [
  { value: "MBBS", label: "MBBS" },
  { value: "BDS", label: "BDS" },
  { value: "BAMS", label: "BAMS" },
  { value: "BHMS", label: "BHMS" },
  { value: "BUMS", label: "BUMS" },
  { value: "BNYS", label: "BNYS" },
  { value: "MD", label: "MD" },
  { value: "MS", label: "MS" },
  { value: "MDS", label: "MDS" },
  { value: "DNB", label: "DNB" },
  { value: "Diploma", label: "Diploma" },
  { value: "DM", label: "DM" },
  { value: "MCh", label: "MCh" },
  { value: "Fellowship", label: "Fellowship" },
  { value: "MD Radiology", label: "MD Radiology" },
  { value: "MD Pathology", label: "MD Pathology" },
  { value: "MD Microbiology", label: "MD Microbiology" },
  { value: "MD Nuclear Medicine", label: "MD Nuclear Medicine" },
  { value: "MD Psychiatry", label: "MD Psychiatry" },
  { value: "MD Physical Medicine & Rehabilitation", label: "MD Physical Medicine & Rehabilitation" },
  { value: "MPhil Clinical Psychology", label: "MPhil Clinical Psychology" },
  { value: "PsyD", label: "PsyD" },
  { value: "PhD Clinical Psychology", label: "PhD Clinical Psychology" },
  { value: "MHA", label: "MHA" },
  { value: "MPH", label: "MPH" }
];

const specializationOption = [
  { value: "General Physician / Family Medicine", label: "General Physician / Family Medicine" },
  { value: "Internal Medicine", label: "Internal Medicine" },
  { value: "Cardiology", label: "Cardiology" },
  { value: "Neurology", label: "Neurology" },
  { value: "Pulmonology (Chest)", label: "Pulmonology (Chest)" },
  { value: "Gastroenterology", label: "Gastroenterology" },
  { value: "Nephrology", label: "Nephrology" },
  { value: "Endocrinology", label: "Endocrinology" },
  { value: "Rheumatology", label: "Rheumatology" },
  { value: "Hematology", label: "Hematology" },
  { value: "Infectious Diseases", label: "Infectious Diseases" },
  { value: "General Surgery", label: "General Surgery" },
  { value: "Orthopaedics", label: "Orthopaedics" },
  { value: "Neurosurgery", label: "Neurosurgery" },
  { value: "Cardiothoracic & Vascular Surgery (CTVS)", label: "Cardiothoracic & Vascular Surgery (CTVS)" },
  { value: "Plastic & Reconstructive Surgery", label: "Plastic & Reconstructive Surgery" },
  { value: "Urology", label: "Urology" },
  { value: "Surgical Gastroenterology", label: "Surgical Gastroenterology" },
  { value: "Pediatric Surgery", label: "Pediatric Surgery" },
  { value: "Obstetrics & Gynaecology", label: "Obstetrics & Gynaecology" },
  { value: "Pediatrics", label: "Pediatrics" },
  { value: "Neonatology", label: "Neonatology" },
  { value: "Psychiatry", label: "Psychiatry" },
  { value: "Clinical Psychology", label: "Clinical Psychology" },
  { value: "Dermatology", label: "Dermatology" },
  { value: "Ophthalmology", label: "Ophthalmology" },
  { value: "ENT (Otorhinolaryngology)", label: "ENT (Otorhinolaryngology)" },
  { value: "Dentistry", label: "Dentistry" },
  { value: "Radiology", label: "Radiology" },
  { value: "Pathology", label: "Pathology" },
  { value: "Nuclear Medicine", label: "Nuclear Medicine" },
  { value: "Medical Oncology", label: "Medical Oncology" },
  { value: "Surgical Oncology", label: "Surgical Oncology" },
  { value: "Radiation Oncology", label: "Radiation Oncology" },
  { value: "Emergency Medicine", label: "Emergency Medicine" },
  { value: "Critical Care / Intensivist", label: "Critical Care / Intensivist" },
  { value: "Physical Medicine & Rehabilitation", label: "Physical Medicine & Rehabilitation" },
  { value: "Sports Medicine", label: "Sports Medicine" },
  { value: "Pain Management", label: "Pain Management" },
  { value: "Palliative Care", label: "Palliative Care" },
];

const languagesOptions = [
  { value: "Assamese", label: "Assamese" },
  { value: "Bengali", label: "Bengali" },
  { value: "Bodo", label: "Bodo" },
  { value: "Dogri", label: "Dogri" },
  { value: "English", label: "English" },
  { value: "Gujarati", label: "Gujarati" },
  { value: "Kannada", label: "Kannada" },
  { value: "Kashmiri", label: "Kashmiri" },
  { value: "Konkani", label: "Konkani" },
  { value: "Maithili", label: "Maithili" },
  { value: "Malayalam", label: "Malayalam" },
  { value: "Manipuri", label: "Manipuri" },
  { value: "Marathi", label: "Marathi" },
  { value: "Nepali", label: "Nepali" },
  { value: "Odia", label: "Odia" },
  { value: "Punjabi", label: "Punjabi" },
  { value: "Santali", label: "Santali" },
  { value: "Sindhi", label: "Sindhi" },
  { value: "Tamil", label: "Tamil" },
  { value: "Telugu", label: "Telugu" },
  { value: "Hindi", label: "Hindi" },
  { value: "Urdu", label: "Urdu" },
];



const AddDoctorModal = ({ mounted, show, onClose, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    specializations: [],
    qualification: [],
    years_of_experience: "",
    languages: [],
    phone: "",
    email: "",
    pincode: "",
    city: "",
    state: "",
    address_line1: "",
    address_line2: "",
  });
  const [errors, setErrors] = useState({});

  // useEffect(() => {
  //   if (show) {
  //     setFormData({
  //       first_name: "",
  //       last_name: "",
  //       specialization: [],
  //       qualification: [],
  //       years_of_experience: "",
  //       languages: [],
  //       phone: "",
  //       email: "",
  //       city: "",
  //     });
  //     setErrors({});
  //   }
  // }, [show]);
  useEffect(() => {
    if (show) {
      setFormData({
        first_name: "",
        last_name: "",
        specializations: [],
        qualification: [],
        years_of_experience: "",
        languages: [],
        phone: "",
        email: "",
        pincode: "",
        city: "",
        state: "",
        address_line1: "",
        address_line2: "",
      });
      setErrors({});
    }
  }, [show]);


  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  //   const validate = () => {
  //     const newErrors = {};

  //     if (!formData.first_name || formData.first_name.trim() === "") {
  //       newErrors.first_name = "First name is required";
  //     }

  //     if (!formData.last_name || formData.last_name.trim() === "") {
  //       newErrors.last_name = "Last name is required";
  //     }

  //     if (!formData.qualification.length) {
  //       newErrors.qualification = "At least one qualification is required";
  //     }

  //     if (!formData.specialization.length) {
  //       newErrors.specialization = "At least one specialization is required";
  //     }

  //     if (formData.years_of_experience && isNaN(formData.years_of_experience)) {
  //       newErrors.years_of_experience =
  //         "Years of experience must be a valid number";
  //     }
  //     if (!formData.city || formData.city.trim() === "") {
  //       newErrors.city = "City is required";
  //     }

  //     if (!formData.languages.length) {
  //       newErrors.languages = "At least one language is required";
  //     }

  //     if (formData.phone && formData.phone.trim()) {
  //       const cleaned = formData.phone.replace(/\D/g, "");
  //       if (cleaned.length !== 10) {
  //         newErrors.phone = "Phone number must be exactly 10 digits";
  //       }
  //     }

  //     if (formData.email && formData.email.trim()) {
  //       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //       if (!emailRegex.test(formData.email)) {
  //         newErrors.email = "Please enter a valid email address";
  //       }
  //     }
  //     if (!formData.address_line1 || formData.address_line1.trim() === "") {
  //   newErrors.address_line1 = "Address Line 1 is required";
  // }

  //     setErrors(newErrors);
  //     return Object.keys(newErrors).length === 0;
  //   };

  // const handleSubmit = () => {
  //   if (validate()) {
  //     onSubmit(formData);
  //   }
  // };
  const validate = () => {
    const newErrors = {};

    // First Name
    if (!formData.first_name.trim()) {
      newErrors.first_name = "First name is required";
    }

    // Last Name
    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last name is required";
    }

    // Qualification
    if (!formData.qualification.length) {
      newErrors.qualification = "At least one qualification is required";
    }

    // Specialization
    if (!formData.specializations.length) {
      newErrors.specialization = "At least one specialization is required";
    }

    // Years of Experience
    if (
      formData.years_of_experience === "" ||
      isNaN(formData.years_of_experience) ||
      Number(formData.years_of_experience) < 0
    ) {
      newErrors.years_of_experience =
        "Years of experience is required and must be a valid number";
    }

    // Languages
    if (!formData.languages.length) {
      newErrors.languages = "At least one language is required";
    }

    // Phone (required + 10 digits)
    if (!formData.phone) {
      newErrors.phone = "Whatsapp number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be exactly 10 digits";
    }

    // Email (required + valid)
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    // Address Line 1
    if (!formData.address_line1.trim()) {
      newErrors.address_line1 = "Address Line 1 is required";
    }

    // Pincode
    if (!formData.pincode) {
      newErrors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = "Pincode must be exactly 6 digits";
    }

    // City
    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    // State
    if (!formData.state.trim()) {
      newErrors.state = "State is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const payload = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      years_of_experience: Number(formData.years_of_experience),
      mobile: formData.phone,
      email: formData.email,
      // city: formData.city,

      // ✅ backend keys
      specializations: formData.specializations.map(s => s.value),
      qualifications: formData.qualification.map(q => q.value),
      languages: formData.languages.map(l => l.value),
      address: {
        address_line1: formData.address_line1,
        address_line2: formData.address_line2,
        pincode: formData.pincode,
        city: formData.city,
        state: formData.state,
      },
    };

    onSubmit(payload);
  };



  const fetchCityState = async (pincode) => {
    if (pincode.length !== 6) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v3/apis/webapi/v4/pincode/detail/?pincode=${pincode}`
      );
      const data = await res.json();

      if (data?.metadata?.api_status && data?.msg) {
        setFormData((prev) => ({
          ...prev,
          city: data.msg.district,
          state: data.msg.state,
        }));
      } else {
        setFormData((prev) => ({ ...prev, city: "", state: "" }));
      }
    } catch {
      /* silently ignore */
    }
  };



  if (!mounted || !show) return null;

  return createPortal(
    <div className="fixed top-0 left-0 w-screen h-screen bg-black/80 z-[9999] m-0 p-0 flex items-center justify-center overflow-y-auto">
      <div className="bg-white rounded-lg border border-gray-200 w-full max-w-2xl shadow-xl m-6 my-8">
        <div className="px-6 py-4 border-b flex items-center justify-between sticky top-0 bg-white z-10">
          <h2 className="text-lg font-semibold text-gray-900">Add Doctor</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            disabled={loading}
          >
            <FaTimes />
          </button>
        </div>
        <div className="p-6 space-y-4 max-h-[calc(100vh-200px)] overflow-y-auto">
          {errors.api && (
            <div className="text-sm text-red-600 bg-red-50 p-2 rounded">
              {errors.api}
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                First Name *
              </label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.first_name ? "border-red-500" : "border-gray-300"}`}
                value={formData.first_name}
                onChange={(e) => handleChange("first_name", e.target.value)}
                placeholder="Enter first name"
                disabled={loading}
              />
              {errors.first_name && (
                <p className="text-xs text-red-500 mt-1">{errors.first_name}</p>
              )}
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Last Name *
              </label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.last_name ? "border-red-500" : "border-gray-300"}`}
                value={formData.last_name}
                onChange={(e) => handleChange("last_name", e.target.value)}
                placeholder="Enter last name"
                disabled={loading}
              />
              {errors.last_name && (
                <p className="text-xs text-red-500 mt-1">{errors.last_name}</p>
              )}
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Specialization *
              </label>

              <Select
                isMulti
                options={specializationOption}
                value={formData.specializations}
                onChange={(selected) =>
                  handleChange("specializations", selected)
                }
              />

              {errors.specialization && (
                <p className="text-xs text-red-500 mt-1">
                  {errors.specialization}
                </p>
              )}
            </div>

            {/* <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Qualification *</label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.qualification ? 'border-red-500' : 'border-gray-300'}`}
                value={formData.qualification}
                onChange={(e) => handleChange('qualification', e.target.value)}
                placeholder="e.g., MBBS, MD, MS"
                disabled={loading}
              />
              {errors.qualification && <p className="text-xs text-red-500 mt-1">{errors.qualification}</p>}
            </div> */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Qualification *
              </label>

              <Select
                isMulti
                options={qualificationOptions}
                value={formData.qualification}
                onChange={(selected) =>
                  handleChange("qualification", selected)
                }
              />
              {errors.qualification && (
                <p className="text-xs text-red-500 mt-1">
                  {errors.qualification}
                </p>
              )}
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Years of Experience *
              </label>
              <input
                type="number"
                min="0"
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.years_of_experience ? "border-red-500" : "border-gray-300"}`}
                value={formData.years_of_experience}
                onChange={(e) =>
                  handleChange("years_of_experience", e.target.value)
                }
                placeholder="Years of experience"
                disabled={loading}
              />
              {errors.years_of_experience && (
                <p className="text-xs text-red-500 mt-1">
                  {errors.years_of_experience}
                </p>
              )}
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Languages *
              </label>

              <Select
                isMulti
                options={languagesOptions}
                value={formData.languages}
                onChange={(selected) =>
                  handleChange("languages", selected)
                }
              />

              {errors.languages && (
                <p className="text-xs text-red-500 mt-1">{errors.languages}</p>
              )}
            </div>


            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Whatsapp Number *
              </label>
              <input
                type="tel"
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.phone ? "border-red-500" : "border-gray-300"}`}
                placeholder="9876543210"
                value={formData.phone}
                onChange={(e) => {
                  const value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                  handleChange("phone", value);
                }}
                disabled={loading}
              />
              {errors.phone && (
                <p className="text-xs text-red-500 mt-1">{errors.phone}</p>
              )}
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Email *
              </label>
              <input
                type="email"
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.email ? "border-red-500" : "border-gray-300"}`}
                placeholder="email@example.com"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                disabled={loading}
              />
              {errors.email && (
                <p className="text-xs text-red-500 mt-1">{errors.email}</p>
              )}
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Address Line 1 *
              </label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.address_line1 ? "border-red-500" : "border-gray-300"
                  }`}
                placeholder="Enter address line 1"
                value={formData.address_line1}
                onChange={(e) => handleChange("address_line1", e.target.value)}
                disabled={loading}
              />
              {errors.address_line1 && (
                <p className="text-xs text-red-500 mt-1">{errors.address_line1}</p>
              )}
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Address Line 2
              </label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.address_line2 ? "border-red-500" : "border-gray-300"
                  }`}
                placeholder="Enter address line 2"
                value={formData.address_line2}
                onChange={(e) => handleChange("address_line2", e.target.value)}
                disabled={loading}
              />
              {errors.address_line2 && (
                <p className="text-xs text-red-500 mt-1">{errors.address_line2}</p>
              )}
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Pincode *
              </label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.city ? "border-red-500" : "border-gray-300"
                  }`}
                placeholder="Enter pincode"
                value={formData.pincode}
                onChange={(e) => {
                  const v = e.target.value.replace(/\D/g, "").slice(0, 6);
                  handleChange("pincode", v);
                  if (v.length === 6) fetchCityState(v);
                }}
                disabled={loading}
              />
              {errors.pincode && (
                <p className="text-xs text-red-500 mt-1">{errors.pincode}</p>
              )}
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                City *
              </label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.city ? "border-red-500" : "border-gray-300"
                  }`}
                placeholder="Enter city"
                value={formData.city}
                onChange={(e) => handleChange("city", e.target.value)}
                disabled={loading}
              />
              {errors.city && (
                <p className="text-xs text-red-500 mt-1">{errors.city}</p>
              )}
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                State *
              </label>
              <input
                className={`w-full border rounded-md px-2 py-1.5 text-sm bg-gray-50 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.state ? "border-red-500" : "border-gray-300"
                  }`}
                placeholder="Enter state"
                value={formData.state}
                onChange={(e) => handleChange("state", e.target.value)}
                disabled={loading}
              />
              {errors.state && (
                <p className="text-xs text-red-500 mt-1">{errors.state}</p>
              )}
            </div>
          </div>

          <div className="flex justify-end space-x-2 pt-4 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:text-white hover:bg-blue-600 hover:border-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddDoctorModal;
